var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgP2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.128 54.976C25.5787 53.824 26.24 53.2907 26.112 53.376C30.2933 49.92 33.5787 47.0827 35.968 44.864C38.4 42.6453 40.448 40.32 42.112 37.888C43.776 35.456 44.608 33.088 44.608 30.784C44.608 29.0347 44.2027 27.6693 43.392 26.688C42.5813 25.7067 41.3653 25.216 39.744 25.216C38.1227 25.216 36.8427 25.8347 35.904 27.072C35.008 28.2667 34.56 29.9733 34.56 32.192H24C24.0853 28.5653 24.8533 25.536 26.304 23.104C27.7973 20.672 29.7387 18.88 32.128 17.728C34.56 16.576 37.248 16 40.192 16C45.2693 16 49.088 17.3013 51.648 19.904C54.2507 22.5067 55.552 25.8987 55.552 30.08C55.552 34.6453 53.9947 38.8907 50.88 42.816C47.7653 46.6987 43.7973 50.496 38.976 54.208H56.256V63.104H24.128V54.976Z",
    fill: "#97B1F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP2);
export default __webpack_public_path__ + "static/media/p2.5be7cb067ba769172868ffb651d3ee6e.svg";
export { ForwardRef as ReactComponent };